import * as React from 'react';
import { connect } from 'react-redux';

import * as _ from 'lodash';

import './home.scss';

const HomeComponent = (props: any) => {
  return (
      <header id="home">
        <h1>{props.name}</h1>
        <h5>{props.title}</h5>
      </header>
  );
};

const mapStateToProps = (state: any) => {
  return _.pick(state.cv.basics, ['name', 'title', 'cvUrl']);
};

export default connect(mapStateToProps, null)(HomeComponent);



// WEBPACK FOOTER //
// ./src/components/home/home.component.tsx